import React from "react";
import { Fade } from "react-awesome-reveal";
import "./Platform.css";
import supersetImg from "../../assets/img/superset.avif";
import supersetImg1 from "../../assets/img/superset1.avif";

const Platform = () => {
  return (
    <section className="platform-section">
      <Fade cascade>
        <div className="intro">
          <h2>Built for Data, Designed for Intelligence</h2>
          <p>
            At the core of Orbi Nexum is a modern, secure, and cloud-native
            platform — purpose-built for real-time data ingestion, deep
            analytics, and geospatial intelligence at scale.
          </p>
        </div>

        {/* First Row: Image + Capabilities */}
        <div className="content-row">
          <div className="left-image match-height">
            <img src={supersetImg} alt="Superset visual 1" />
          </div>

          <div className="right-content match-height">
            <div className="key-capabilities">
              <h3>Key Capabilities:</h3>
              <ul>
                <li>
                  <strong>Geospatial Native:</strong> Supports GeoJSON,
                  shapefiles, raster, and vector formats for seamless map-based
                  analytics.
                </li>
                <li>
                  <strong>Predictive Location Intelligence:</strong> Enable
                  dynamic modeling with predictive overlays across territories,
                  weather, demographics, and behaviors.
                </li>
                <li>
                  <strong>Collaborative & Secure:</strong> Securely blend
                  internal and third-party data across teams, partners, or
                  global divisions — all with fine-grained access control.
                </li>
              </ul>
              <h3 style={{ marginTop: "2rem" }}>Inspired by:</h3>
              <ul>
                <li>The interactivity and spatial precision of OrbiNexum</li>
                <li>
                  The scalability, data sharing, and multi-source integration of
                  OrbiNexum
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Second Row: Use Cases + Second Image */}
        <div className="content-row reverse">
          <div className="right-content match-height">
            <div className="use-cases">
              <h3>Use Cases</h3>

              <div className="use-case retail">
                <h4>
                  Retail: Location-Based Expansion Strategy for a Mid-Sized
                  Retailer
                </h4>
                <p>
                  We helped a national retail chain identify high-potential
                  expansion zones by combining POS data, customer loyalty
                  behavior, competitor density, and demographic maps. <br />
                  <strong>Result:</strong> a 25% increase in foot traffic within
                  3 months of store openings.
                </p>
              </div>

              <div className="use-case manufacturing">
                <h4>
                  Manufacturing: Predictive Maintenance Through Sensor + Spatial
                  Correlation
                </h4>
                <p>
                  A global manufacturer reduced unplanned downtime by 38% by
                  correlating geotagged machine performance data with
                  environmental factors like humidity, temperature, and supply
                  delays, improving maintenance schedules and reducing
                  bottlenecks.
                </p>
              </div>

              <div className="use-case telecom">
                <h4>
                  Telecom: Reducing Churn via Geospatial Signal Quality Mapping
                </h4>
                <p>
                  By overlaying call drop density, network quality metrics, and
                  customer complaints across city grids, a telecom provider
                  identified poor-performing zones. <br />
                  <strong>Result:</strong> Strategic network investments reduced
                  churn by 18% in affected regions within two quarters.
                </p>
              </div>
            </div>
          </div>

          <div className="left-image match-height">
            <img src={supersetImg1} alt="Superset visual 2" />
          </div>
        </div>
      </Fade>
    </section>
  );
};

export default Platform;
